module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ml-d11c30638f3d7b1766dc9194c76f52f8.svg";